// Mirrors src/auth/utils/password-schema.ts and the Cognito User Pool policy in
// infrastructure/auth/cognito.ts. Keeping these in sync prevents the user from
// hitting a confusing 400/502 after submit when their password silently fails
// Cognito's policy server-side.

export interface PasswordRule {
  id: 'length' | 'upper' | 'lower' | 'number' | 'symbol';
  label: string;
  test: (pw: string) => boolean;
}

// Cognito's symbol set per docs: ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~ ` + =
const SYMBOL_REGEX = /[\^$*.\[\]{}()?\-"!@#%&/\\,><':;|_~`+=]/;

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'At least 8 characters', test: (pw) => pw.length >= 8 },
  { id: 'upper', label: 'An uppercase letter', test: (pw) => /[A-Z]/.test(pw) },
  { id: 'lower', label: 'A lowercase letter', test: (pw) => /[a-z]/.test(pw) },
  { id: 'number', label: 'A number', test: (pw) => /[0-9]/.test(pw) },
  { id: 'symbol', label: 'A symbol (e.g. !@#$)', test: (pw) => SYMBOL_REGEX.test(pw) },
];

function failingPasswordRules(pw: string): PasswordRule[] {
  return PASSWORD_RULES.filter((rule) => !rule.test(pw));
}

export function isPasswordValid(pw: string): boolean {
  return failingPasswordRules(pw).length === 0;
}
